import Article from './article/Article';
import { GeneralContactInput, SocialContactInput } from './contacts/Contacts';
import News from './news/index';
import NavigationBar from './navigation/NavigationBar';
import Header from './header/Header';
import Image from './image/Image';
import Editor from './editor/Editor';
import AboutUs from './about-us/AboutUs';
import Team from './team/Team';
import Services from './services/Services';
import DatePicker from './date-picker/DatePicker';
import RenderDynamicForm from './render-dynamic-form/RenderDynamicForm';
import Service from './Render/Service/Service';
import Modal from './Render/Modal/Modal';
import List from './list/List';
import Field from './Field/Field';
import Partners from './partners/Partners';
import GalleryInput from './gallery-input';

export {
  GalleryInput,
  AboutUs,
  Article,
  GeneralContactInput,
  SocialContactInput,
  DatePicker,
  News,
  NavigationBar,
  Header,
  Image,
  Editor,
  Team,
  Services,
  Service,
  RenderDynamicForm,
  Modal,
  List,
  Field,
  Partners
};



// WEBPACK FOOTER //
// ./src/components/index.js